<script setup lang="ts">
import type { SliderItem } from '@/types/appTypes'

import { Hooper, Slide, Navigation, Pagination } from '@wattanx/hooper-vue3'
import '@wattanx/hooper-vue3/css'

type Props = { items: SliderItem[] }

const props = withDefaults(defineProps<Props>(), {})

const pageData = {
  hooperBanner: {
    itemsToShow: 3,
    initialSlide: 1,
    centerMode: true,
    infiniteScroll: true,
    wheelControl: false,
  },
}

const bannerSlider = ref(null)

const onClickReportPrev = () => {
  bannerSlider.value?.restartTimer()
  bannerSlider.value?.slidePrev()
}
const onClickReportNext = () => {
  bannerSlider.value?.restartTimer()
  bannerSlider.value?.slideNext()
}
</script>

<template>
  <div class="p-banner">
    <div class="p-banner_prev">
      <v-btn
        class="p-banner_prev_button"
        v-on:click="onClickReportPrev"
      >
        <v-icon size="large">
          mdi-chevron-left
        </v-icon>
      </v-btn>
    </div>
    <div class="p-banner_slider">
      <hooper
        key="banner"
        ref="bannerSlider"
        v-bind:settings="pageData.hooperBanner"
        auto-play
        v-bind:play-speed="4000"
        v-bind:transition="600"
      >
        <slide
          v-for="(item, index) in items"
          v-bind:key="index"
          class="l-blank-icon-none"
        >
          <template
            v-if="!item.outLink"
          >
            <nuxt-link
              class="p-banner_slider_img"
              v-bind:to="item.link"
            >
              <CommonImage
                v-bind:src="item.image.url"
                error-src="/images/noimage.svg"
                v-bind:alt="item.title"
                object-fit="contain"
              />
            </nuxt-link>
          </template>
          <template
            v-else
          >
            <a
              v-bind:href="item.link"
              class="p-banner_slider_img"
              target="_blank"
            >
              <CommonImage
                v-bind:src="item.image.url"
                error-src="/images/noimage.svg"
                v-bind:alt="item.title"
                object-fit="contain"
              />
            </a>
          </template>
        </slide>
      </hooper>
    </div>
    <div class="p-banner_next">
      <v-btn
        class="p-banner_next_button"
        v-on:click="onClickReportNext"
      >
        <v-icon size="large">
          mdi-chevron-right
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive" as responsive;

.p-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 40px 0;
  background-color: var(--color_background_whiteblue);

  @include responsive.mq_down(sp) {
    display: block;
    position: relative;
    height: 116px;
    overflow: hidden;
  }

  &_prev {
    &_button {
      height: 40px !important;
      margin-right: 5px;
      border-radius: 0;
      box-shadow: none;

      @include responsive.mq_down(top_banner_slider) {
        display: none;
      }

      &.theme--light.v-btn:not(.v-btn--flat, .v-btn--text, .v-btn--outlined) {
        background-color: transparent;
      }
    }
  }

  &_next {
    &_button {
      height: 40px !important;
      margin-left: 5px;
      border-radius: 0;
      box-shadow: none;

      @include responsive.mq_down(top_banner_slider) {
        display: none;
      }

      &.theme--light.v-btn:not(.v-btn--flat, .v-btn--text, .v-btn--outlined) {
        background-color: transparent;
      }
    }
  }

  &_slider {
    display: flex;
    justify-content: center;
    width: var(--g_max_content_width);

    @include responsive.mq_down(sp) {
      display: block;
      position: absolute;
      top: 20px;
      left: 50%;
      width: 660px;
      min-width: 660px;
      height: 76px;
      margin-left: -330px;
    }

    &_img {
      display: block;
      width: 346px;
      height: 126px;
      margin-right: 10px;
      margin-left: 10px;
      padding: 0;
      overflow: hidden;

      &:hover {
        opacity: 0.8;
      }

      @include responsive.mq_down(sp) {
        width: auto;
        height: auto;
        margin-right: 5px;
        margin-left: 5px;
      }
    }

    // .hooper-slide {
    //   padding: 0 1%;
    // }
  }
}

.mdi-chevron-right {
  // display: none;
  // box-shadow: none;
}
</style>
